import React from 'react'

import styled, { keyframes } from 'styled-components'
import {
	Absolute,
	BackgroundImage,
	Border,
	Box,
	Container,
	Flex,
	Image,
	Heading,
	Measure,
	Subhead,
	Relative,
	Text,
} from 'rebass'
import { fadeIn } from 'react-animations'

import IconBuild from '../utils/icons/icon-build.js'
import IconTeam from '../utils/icons/icon-team.js'
import IconMpv from '../utils/icons/icon-mpv.js'
import IconConsulting from '../utils/icons/icon-consulting.js'

const FadeDiv = styled.div`
	animation: 3s ${fadeAnimation};
`

const fadeAnimation = keyframes`${fadeIn}`

const ServiceIcons = () => (
	<section>
		<Box pt={2} pb={5} bg="#F0F8FD">
			<Container>
				<Flex
					pb={3}
					flexWrap="wrap"
					flexDirection="row"
					alignItems={['center', 'center', 'flex-start']}
					justifyContent={['flex-start', 'center', 'space-between']}
				>
					<Box mt={5}>
						<Flex
							flexWrap={['wrap', 'nowrap', 'nowrap']}
							flexDirection={['column', 'row', 'row']}
							alignItems={['flex-start', 'center', 'center']}
							justifyContent={['space-around', 'space-between', 'space-between']}
						>
							<Border
								p={[3, 4, 4]}
								ml={[4, 0, 0]}
								border={2}
								borderColor="#001f3f"
								color="#001f3f"
								top
								bottom
							>
								<FadeDiv>
									<IconBuild />
								</FadeDiv>
							</Border>
							<Flex
								pl={4}
								flexWrap="nowrap"
								flexDirection="column"
								alignItems="flex-start"
								justifyContent="space-around"
							>
								<Subhead
									fontWeight={600}
									mt={[4, 0, 0]}
									fontSize={[1, 3, 3]}
									color="#001f3f"
									children="Building Software"
								/>
								<Measure
									mt={3}
									fontSize={2}
									lineHeight={1.7}
									color="#3f3f3f"
									maxWidth="18em"
									children="We can use our experience to build mobile application, content management systems, e-commerce, realtime web applications, and everything in between."
								/>
							</Flex>
						</Flex>
					</Box>
					<Box mt={5}>
						<Flex
							flexWrap={['wrap', 'nowrap', 'nowrap']}
							flexDirection={['column', 'row', 'row']}
							alignItems={['flex-start', 'center', 'center']}
							justifyContent={['space-around', 'space-between', 'space-between']}
						>
							<Border
								p={[3, 4, 4]}
								ml={[4, 0, 0]}
								border={2}
								borderColor="#001f3f"
								color="#001f3f"
								top
								bottom
							>
								<FadeDiv>
									<IconMpv />
								</FadeDiv>
							</Border>
							<Flex
								pl={4}
								flexWrap="nowrap"
								flexDirection="column"
								alignItems="flex-start"
								justifyContent="space-around"
							>
								<Subhead
									fontWeight={600}
									mt={[4, 0, 0]}
									fontSize={[1, 3, 3]}
									color="#001f3f"
									children="MVP Development"
								/>
								<Measure
									mt={3}
									fontSize={2}
									lineHeight={1.7}
									color="#3f3f3f"
									maxWidth="18em"
									children="Build your minimum viable product and go to market quickly with a solid foundation, prioritizing your must-have features on time and budget."
								/>
							</Flex>
						</Flex>
					</Box>
					<Box mt={5}>
						<Flex
							flexWrap={['wrap', 'nowrap', 'nowrap']}
							flexDirection={['column', 'row', 'row']}
							alignItems={['flex-start', 'center', 'center']}
							justifyContent={['space-around', 'space-between', 'space-between']}
						>
							<Border
								p={[3, 4, 4]}
								ml={[4, 0, 0]}
								border={2}
								borderColor="#001f3f"
								color="#001f3f"
								top
								bottom
							>
								<FadeDiv>
									<IconTeam />
								</FadeDiv>
							</Border>
							<Flex
								pl={4}
								flexWrap="nowrap"
								flexDirection="column"
								alignItems="flex-start"
								justifyContent="space-around"
							>
								<Subhead
									fontWeight={600}
									mt={[4, 0, 0]}
									fontSize={[1, 3, 3]}
									color="#001f3f"
									children="Team Augmentation"
								/>
								<Measure
									mt={3}
									fontSize={2}
									lineHeight={1.7}
									color="#3f3f3f"
									maxWidth="18em"
									children="We can seamlessly integrate with your engineering team and bring in development expertise while producing the highest quality code."
								/>
							</Flex>
						</Flex>
					</Box>
					<Box mt={5}>
						<Flex
							flexWrap={['wrap', 'nowrap', 'nowrap']}
							flexDirection={['column', 'row', 'row']}
							alignItems={['flex-start', 'center', 'center']}
							justifyContent={['space-around', 'space-between', 'space-between']}
						>
							<Border
								p={[3, 4, 4]}
								ml={[4, 0, 0]}
								border={2}
								borderColor="#001f3f"
								color="#001f3f"
								top
								bottom
							>
								<FadeDiv>
									<IconConsulting />
								</FadeDiv>
							</Border>
							<Flex
								pl={4}
								flexWrap="nowrap"
								flexDirection="column"
								alignItems="flex-start"
								justifyContent="space-around"
							>
								<Subhead
									fontWeight={600}
									mt={[4, 0, 0]}
									fontSize={[1, 3, 3]}
									color="#001f3f"
									children="Consulting"
								/>
								<Measure
									mt={3}
									fontSize={2}
									lineHeight={1.7}
									color="#3f3f3f"
									maxWidth="18em"
									children="Our team can coach your team to become better engineers, better remote workers, or get up-to-speed with modern development practices."
								/>
							</Flex>
						</Flex>
					</Box>
				</Flex>
			</Container>
		</Box>
	</section>
)

export default ServiceIcons



// WEBPACK FOOTER //
// ./src/components/services.js